import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { handleApiError } from 'src/app/helper/helper';
import { ScanMap } from 'src/app/interfaces/scan.interfaces';
import { FieldMap, MapArea } from 'src/app/interfaces/stellar-cartography.interfaces';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-stellar-cartography',
  templateUrl: './stellar-cartography.component.html',
})
export class StellarCartographyComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  isLoaded = false;
  error: any = null;

  selected = { x: 257, y: 18 };
  center = { x: 257, y: 18, r: 10 };

  fields: FieldMap = {};
  scans: ScanMap = {};

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.subscription = this.route.paramMap.subscribe((params) => {
      const x = Number.parseInt(params.get('x') || '257');
      const y = Number.parseInt(params.get('y') || '18');

      this.center.x = x;
      this.center.y = y;
      this.selected.x = x;
      this.selected.y = y;

      this.fetchData(x, y, this.center.r);
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  async fetchData(x: number, y: number, r: number) {
    const area: MapArea = {
      startX: x - r,
      startY: y - r,
      endX: x + r,
      endY: y + r,
    };

    try {
      const [fields, scans] = await Promise.all([
        this.apiService.fetchFields(area.startX, area.startY, area.endX, area.endY),
        this.apiService.fetchScanArea(area.startX, area.startY, area.endX, area.endY)
      ]);

      this.fields = fields;
      this.scans = scans;
      this.isLoaded = true;
    } catch (error) {
      handleApiError(this.authService, this.router, error);
      this.error = error;
    }
  }

  onMapClick(event: { x: number; y: number }) {
    if (this.selected.x === event.x && this.selected.y === event.y) {
      this.fetchData(event.x, event.y, this.center.r);
    } else {
      this.selected = { x: event.x, y: event.y };
    }
  }

  onSectorSubmit(event: { x: number; y: number }) {
    this.router.navigate(['/stellar-cartography', event.y, event.x]);
  }

  get currentScan() {
    return this.scans[this.selected.y] ? this.scans[this.selected.y][this.selected.x] : undefined;
  }
}
